// 新手配置教程管理
import http from "@/jslibs/axios/http";

// 获取新手教程
export const detail = () => http.get("/cms/base/tutorial");

// 编辑新手教程
export const edit = (data) => http.post("/cms/base/tutorial", data);
